import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../api";
import { STATUS_LABEL, STATUS_CLASS } from "../projectMeta";

export default function ProjectList() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  async function load(query = "") {
    setError("");
    try {
      const data = await api.get(`/projects${query ? `?q=${encodeURIComponent(query)}` : ""}`);
      setRows(data);
    } catch (err) {
      setError(err.message);
    }
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <div>
      <div className="sstoa-topbar">
        <div>
          <h1 className="sstoa-title">프로젝트 관리</h1>
          <p className="sstoa-sub">진행 중인 일과 참여 업체를 한 곳에서 관리합니다.</p>
        </div>
        <Link to="/sstoa/projects/new" className="sstoa-btn sstoa-btn--primary">+ 프로젝트 등록</Link>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          load(q);
        }}
        style={{ display: "flex", gap: 8, marginBottom: 16, maxWidth: 420 }}
      >
        <input
          className="sstoa-input"
          placeholder="프로젝트명 검색"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <button className="sstoa-btn" type="submit">검색</button>
      </form>

      {error && <div className="sstoa-error">{error}</div>}

      <div className="sstoa-panel">
        {rows === null ? (
          <div className="sstoa-empty">불러오는 중…</div>
        ) : rows.length === 0 ? (
          <div className="sstoa-empty">등록된 프로젝트가 없습니다. 우측 상단에서 새로 등록하세요.</div>
        ) : (
          <table className="sstoa-table">
            <thead>
              <tr>
                <th>프로젝트명</th>
                <th>상태</th>
                <th>시작일</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.id} onClick={() => navigate(`/sstoa/projects/${p.id}`)}>
                  <td style={{ fontWeight: 600 }}>{p.name}</td>
                  <td><span className={`sstoa-tag ${STATUS_CLASS[p.status] || ""}`}>{STATUS_LABEL[p.status] || p.status}</span></td>
                  <td>{p.start_date || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
